import React, { useEffect, useMemo, useState } from 'react'
import { EditCartItemProps, SipValidationType } from '../types'
import { Box, Grid, Skeleton, Theme, Typography, useTheme } from '@mui/material'
import { Formik, useFormik } from '../../../lib/formik/Formik';
import { SipScheme } from './Scheme';
import dayjs from '../../../utils/dayjs';
import { getMandatesList } from '../../../redux-store/actions/investorProfile';
import { MandatesListResBody } from '../../../redux-store/types/investorProfile';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../../redux-store/reducers';
import { MpowerValidationType } from '../../investorOverview/types';
import { InvestmentFundType } from '../../../redux-store/types/api-types';
import { formatCurrency, getDailyFreqInstallmentsMsg, addWorkingDays } from '../../../utils/utilityFunctions';
import { CustomeBlueDatePicker, CustomeBlueDropDown, CustomeModalButton, CustomeNumberInput } from '../../investorOverview/transcation/FromInput';
import { BANK_SUB_ACCOUNT_TYPES, WEEKLYDAYS } from '../../../utils/constant';
import MFCheckbox from '../../../lib/formik/Checkbox';
import { InfoIconOutlined } from '../../../assets/SvgIcons';

type Props = {
    data: EditCartItemProps
    currentTransactionType: string
    validation: SipValidationType,
    folio: string[]
    schemeLoading: boolean
    scheme: InvestmentFundType

}

export const handleDateValidation = (ArrayOfDate: Array<string | number>, date: dayjs.Dayjs) => {

    if (ArrayOfDate?.length === 0) {
        return false
    }
    if (typeof ArrayOfDate?.[0] === 'number') {
        return !ArrayOfDate?.includes(dayjs(date).date());
    }

    if (typeof ArrayOfDate?.[0] === 'string') {
        const capitalizedDays = ArrayOfDate.map(day =>
            day.toString().charAt(0) + day.toString().slice(1).toLowerCase()
        );
        const day = capitalizedDays.map(item => WEEKLYDAYS.indexOf(item))
        return !day?.includes(dayjs(date).day());
    }
    return false
}

export default function Sip(props: Props) {
    const theme = useTheme()
    const dispatch = useDispatch()

    const { investorClientId } = useSelector((store: RootStateType) => store.id)
    const { data, currentTransactionType, validation, folio, schemeLoading, scheme } = props
    const { onSave, sipAmount, frequency, onCancel, noOfInstallments, sipDate, endDate, mandate, isLoading, activeCategory, folioNumber, firstOrder } = data
    const [activeMandateList, setActiveMandateList] = useState<MandatesListResBody[]>([]);

    // sheme
    const schemeValidation = SipScheme({ scheme, sipAmount, frequency, noOfInstallments, sipDate, endDate, activeCategory, mandate })
    const { selectedPortfolio } = useSelector((state: RootStateType) => state.selectedPortfiolio)
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);




    useEffect(() => {
        const fetch = async () => {
            if (investorClientId) {
                const list = await (dispatch(getMandatesList({ clientCode: investorClientId, status: "Active", portfolioId: selectedPortfolio?.value })) as unknown as Promise<Array<MandatesListResBody>>);
                setActiveMandateList(list);
            }
        }
        fetch();
    }, [investorClientId])

    function drowDownDateFormate(array: Array<MandatesListResBody>) {
        return array?.map((item: MandatesListResBody) => {
            return {
                label: `
                ${item?.displayText} 
                ${BANK_SUB_ACCOUNT_TYPES[`${item?.bankSubAccountType ?? ""}`.toUpperCase()] ? "(" + BANK_SUB_ACCOUNT_TYPES[`${item?.bankSubAccountType ?? ""}`.toUpperCase()] + ")" : ""}
                `,
                value: item?.mandateId
            }
        })
    }



    // handleSubmit
    function handleSubmitBtn(formValues: any) {
        const modifiedSipDate = dayjs(formValues.sipDate).format('DD/MM/YYYY')
        const modifiedSipEndDate = dayjs(formValues.endDate).format('DD/MM/YYYY')

        onSave(
            data.id,
            currentTransactionType,
            {
                amount: formValues.sipAmount,
                frequency: formValues.frequency,
                noOfInstallment: `${formValues?.frequency ?? ""}`.toLowerCase() === "daily" ? 0 : formValues.noOfInstallments,
                sipDate: modifiedSipDate,
                endDate: `${formValues?.frequency ?? ""}`.toLowerCase() === "daily" ? modifiedSipEndDate : "",
                mandateId: formValues.mandates,
                firstOrderFlag: formValues.firstOrder ? "Y" : "N",
                ...(activeCategory === "New Purchase" ? { folio: formValues.folios } : {})
            }
        )
    }

    const frequencyArray = scheme?.frequencies?.filter(item => item.frequency && item.tranasactionType === 'SIP')
    const Daily = scheme?.validations?.filter((item) => item?.frequency === 'DAILY' && item?.transactionType === 'SIP')?.[0]
    const Weekly = scheme?.validations?.filter((item) => item?.frequency === 'WEEKLY' && item?.transactionType === 'SIP')?.[0]
    const WeeklyDays = scheme?.validations?.filter((item) => item?.frequency === 'WEEKLYDAYS' && item?.transactionType === 'SIP')?.[0]
    const Monthly = scheme?.validations?.filter((item) => item?.frequency === 'MONTHLY' && item?.transactionType === 'SIP')?.[0]
    const Quarterly = scheme?.validations?.filter((item) => item?.frequency === 'QUARTERLY' && item?.transactionType === 'SIP')?.[0]
    const Yearly = scheme?.validations?.filter((item) => item?.frequency === 'YEARLY' && item?.transactionType === 'SIP')?.[0]

    const sipMinAmount = (key = 'minimumInstallmentAmount' as keyof MpowerValidationType, frequency: string) => {

        if (frequency === 'WEEKLY') {
            return Weekly?.[key]
        } else if (frequency === 'MONTHLY') {
            return Monthly?.[key]
        } else if (frequency === 'QUARTERLY') {
            return Quarterly?.[key]
        } else if (frequency === 'YEARLY') {
            return Yearly?.[key]
        } else if (frequency === 'DAILY') {
            return Daily?.[key]
        } else if (frequency === 'WEEKLYDAYS') {
            return WeeklyDays?.[key]
        } else {
            return 0
        }
    }

    return (
        <Formik
            enableReinitialize
            initialValues={{
                sipAmount: sipAmount || '0',
                frequency: frequency || '',
                noOfInstallments: noOfInstallments || '0',
                sipDate: sipDate ? dayjs(sipDate, 'DD/MM/YYYY') : '',
                endDate: endDate ? dayjs(endDate, 'DD/MM/YYYY') : '',
                mandates: mandate || '',
                firstOrder: firstOrder,
                ...(activeCategory === "New Purchase" ? { folios: folioNumber } : {})
            }}
            validationSchema={schemeValidation}
            onSubmit={handleSubmitBtn}>

            {(formik) => {
                const selectedMandateObj = (activeMandateList ?? []).find(obj => obj.mandateId === formik.values.mandates)
                return (
                    <Box component={'form'} onSubmit={formik.handleSubmit} noValidate>
                        <Grid container spacing={2}>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <CustomeNumberInput
                                    isLoading={schemeLoading}
                                    disable={isLoading}
                                    textType="number"
                                    label='SIP Amount'
                                    name={`sipAmount`}
                                    defaultValue={`${sipAmount}`}
                                    minlabel={`Min:${formatCurrency({ value: Number(sipMinAmount('minimumInstallmentAmount', formik.values.frequency) ?? 0), locale, currencyCode })}`}
                                    removeIcons={true}
                                    warningText={'amount'}
                                />
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <CustomeBlueDropDown
                                    name={`frequency`}
                                    disabled={isLoading}
                                    isLoading={schemeLoading}
                                    label='Frequency'
                                    list={frequencyArray?.map(item => ({ value: item.frequency, label: item.frequency })) as any}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                {schemeLoading && (
                                    <Skeleton
                                        variant="rectangular"
                                        width='100%'
                                        height={50}
                                        sx={{ borderRadius: 2 }}
                                    />
                                )}
                                {!schemeLoading && (
                                    <Box
                                        sx={{
                                            mt: 1,
                                            width: '100%',
                                            padding: '4px 0px 4px 15px',
                                            backgroundColor: theme.palette.customColors.darkGrey,
                                            borderRadius: 2
                                        }}
                                    >
                                        <MFCheckbox
                                            name="firstOrder"
                                            label="Pay 1st Installment Today"
                                            disabled
                                        />
                                    </Box>
                                )}
                            </Grid>
                            {(formik.values.frequency !== 'DAILY') && (
                                <Grid item lg={6} md={6} sm={12} xs={12}>
                                    <CustomeNumberInput
                                        isLoading={schemeLoading}
                                        disable={isLoading}
                                        textType="number"
                                        label='No. of Installments'
                                        name={`noOfInstallments`}
                                        defaultValue={`${noOfInstallments}`}
                                        minValue={sipMinAmount('minimumInstallments', formik.values.frequency)}
                                        removeIcons={true}
                                    />
                                </Grid>
                            )}
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <CustomeBlueDatePicker
                                    disabled={isLoading}
                                    name={`sipDate`}
                                    label={(formik.values.frequency === 'DAILY') ? "SIP Start Date" : formik.values.firstOrder ? "Next SIP Date" : "SIP Date"}
                                    isLoading={schemeLoading}
                                    disablePast={true}
                                    // disableDateList={getValidation?.investmentDates}
                                    // For non-first orders, additionally disable weekends (Sat/Sun) so only
                                    // working days (Mon–Fri) can be selected, matching findNextValidDate.
                                    shouldDisableDate={(date: dayjs.Dayjs) =>
                                        handleDateValidation(sipMinAmount('investmentDates', formik.values.frequency) || [], date) ||
                                        (!formik.values.firstOrder && (dayjs(date).day() === 0 || dayjs(date).day() === 6))
                                    }
                                    // minDate={dayjs().add(1, 'day')}
                                    // For non-first orders: earliest date is T+3 working days.
                                    // addWorkingDays skips weekends so the result is always a Mon–Fri.
                                    minDate={!formik.values.firstOrder ? addWorkingDays(dayjs(), 3) : dayjs().add(31, 'days')}
                                />
                            </Grid>
                            {(formik.values.frequency === 'DAILY') && (
                                <Grid item lg={6} md={6} sm={12} xs={12}>
                                    <CustomeBlueDatePicker
                                        name={`endDate`}
                                        isLoading={schemeLoading}
                                        disablePast
                                        disabled={formik.values.sipDate === '' || isLoading}
                                        label="SIP End Date"
                                        shouldDisableDate={(date: dayjs.Dayjs) => dayjs(date).isBefore(dayjs(formik.values.sipDate))}
                                    />
                                </Grid>
                            )}
                            {(!schemeLoading && (formik.values.frequency === 'DAILY')) && (
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        columnGap: "5px",
                                        marginLeft: "16px",
                                        marginTop: "10px"
                                    }}>
                                    <Box sx={{ flexShrink: 0, display: "flex", alignItems: "center" }}>
                                        <InfoIconOutlined />
                                    </Box>
                                    <Typography
                                        variant='subtitle_600'
                                        sx={(theme: Theme) => ({
                                            color: theme.palette.grey[500]
                                        })}
                                    >
                                        {getDailyFreqInstallmentsMsg(Daily?.minimumInstallments ?? 0)}
                                    </Typography>
                                </Box>
                            )}
                            <Grid item lg={6} md={6} sm={12} xs={12} sx={{ paddingBottom: "20px" }}>
                                <CustomeBlueDropDown
                                    name={`mandates`}
                                    isLoading={schemeLoading}
                                    disabled={isLoading}
                                    label='Mandate'
                                    list={drowDownDateFormate(activeMandateList)}
                                />
                                {(
                                    !schemeLoading &&
                                    (Object.keys(selectedMandateObj ?? {}).length > 0)
                                ) && (
                                        <Typography
                                            variant='body_500'
                                            sx={(theme: Theme) => ({
                                                color: theme.palette.text.secondary,
                                                marginTop: "5px"
                                            })}
                                        >
                                            Bank Sub Account Type: {`${BANK_SUB_ACCOUNT_TYPES[`${selectedMandateObj?.bankSubAccountType ?? ""}`.toUpperCase()] ?? "-"}`}
                                        </Typography>
                                    )}
                            </Grid>
                            {activeCategory === "New Purchase" &&
                                <Grid item lg={6} md={6} sm={12} xs={12} sx={{ paddingBottom: "20px" }}>
                                    <CustomeBlueDropDown
                                        isLoading={schemeLoading}
                                        // disabled={isLoading}
                                        disabled
                                        label='Select Folio'
                                        name={'folios'}
                                        list={folio?.map((item: string) => ({ label: item, value: item }))}
                                    />
                                </Grid>
                            }
                            <Grid
                                item
                                container
                                xs={12}
                                mt={2}
                                sx={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                    borderTop: `0.5px solid ${theme.palette.text.secondary}B2`
                                }}
                            >
                                <Grid
                                    item
                                    container
                                    xs={9.5}
                                    sx={{
                                        columnGap: "35px",
                                        flexWrap: "nowrap",
                                        paddingTop: "30px",
                                    }}
                                >
                                    <Grid
                                        item
                                        xs={6}
                                    >
                                        <CustomeModalButton
                                            disabled={isLoading || schemeLoading}
                                            onClick={() => onCancel()}
                                            btnText='Cancel'
                                            variant='outlined'
                                            boxStyle={{
                                                color: theme.palette.text.primary,
                                            }}
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        xs={6}
                                    >
                                        <CustomeModalButton
                                            variant='contained'
                                            disabled={!formik.dirty || schemeLoading}
                                            isLoading={isLoading}
                                            btnText='Save Changes'
                                            type='submit'
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                )
            }}

        </Formik>
    )
}